module.exports = __webpack_public_path__ + "static/media/H1_Small.49dd5e9b.svg";